//
import authMachine from "./machine"
import { actionsNoCare } from "../../../constants/actionsNoCare"
export const { initialState } = authMachine

const login = (state = initialState, action) => {
  //
  if (
    !actionsNoCare.includes(action.type) &&
    !action.type.startsWith("@@") &&
    action.type.startsWith("auth/")
  ) {
    if (!authMachine.states[state.value]?.on?.[action.type]) {
      console.error(
        `authMachine: No hay transición definida para la acción ${action.type} en el estado ${state.value}`
      )
    } else {
      return authMachine.transition(state, action)
    }
  }
  return state
}

export default login
